import { AbiCoder } from "@ethersproject/abi";

export const parseJobData = (job, currentJobInfo) => {
  const abiCoder = new AbiCoder();
  const data = abiCoder.decode(
    ["string", "uint256", "bool", "uint256", "uint256", "bool", "bool"],
    job.jobInfoData
  );
  console.log("data: ", data);
  console.log("jobasdasd: ", job.jobInfoData);

  const jobInfo = {
    name: data[0],
    createdTimestamp: data[1],
    isSmartContractWallet: data[2],
    jobType: data[3],
    initTimestamp: data[4],
    runOnce: data[5],
    isExpired: data[6],
  };

  const nextExecutionDeadline = currentJobInfo?.nextExecutionDeadline
  const isExpired = currentJobInfo?.isExpired

  return {
    ...job,
    ...jobInfo,
    nextExecutionDeadline,
    isExpired,
  };
};

export const shortenBytesData = (bytesData) => {
    console.log("bytesData: ", bytesData);
    if(!bytesData) {
        return ""
    }
    return bytesData.substring(0,15) + "..." + bytesData.substring(bytesData.length - 15)
}